import styled from 'styled-components';

import {breakpoint} from 'theme';

export const HeaderControls = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap-reverse;
    gap: 0.8rem;
    justify-content: flex-end;

    @media (max-width: ${breakpoint.phone}) {
        margin-bottom: 20px;
    }
`;

export const HeaderControlsFakeDiv = styled.div`
    visibility: hidden;
    display: flex;
    gap: 0.8rem;
    min-width: 425px;
    min-height: 43px;
    @media (max-width: ${breakpoint.phone}) {
        display: none;
        min-width: unset;
        flex-wrap: wrap;
        flex-grow: 1;
    }
`;
